<mat-spinner [diameter]="45" color="primary"></mat-spinner>
<span class="loading">Loading..</span>
